import React from "react";
import { Button } from "@ui5/webcomponents-react";
import * as XLSX from "xlsx";

function ImportExcelButton({ onDataImport }) {
  const handleImportExcel = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        // Filtrar y transformar los datos importados
        const formattedData = jsonData
          .map((row, index) => ({
            Pos: index + 1, // Inicia en 1 y sigue progresivamente
            Material: row["Material"] || "",
            Cantidad: row["Cantidad"] || 0,
            Unidad: row["Unidad"] || "",
            Bulto: row["Bulto"] || "",
          }))
          .filter((item) => item.Material && item.Cantidad > 0); // Eliminar filas vacías

        onDataImport(formattedData); // Envía los datos procesados al componente padre
      };
      reader.readAsArrayBuffer(file);
    }
  };

  return (
    <div>
      <Button
        style={{ backgroundColor: 'green', color: 'white' }}
        icon="upload"
        onClick={() => document.getElementById("excelInput")?.click()}
      >
        Importar
      </Button>
      <input
        id="excelInput"
        type="file"
        accept=".xlsx, .xls"
        style={{ display: "none" }}
        onChange={handleImportExcel}
      />
    </div>
  );
}

export default ImportExcelButton;
